var _templateObject, _templateObject2;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import { motion } from 'framer-motion';
export var Container = styled(motion.div).withConfig({
  displayName: "elements__Container",
  componentId: "lafckj-0"
})(["position:fixed;display:grid;justify-content:center;align-content:center;top:0;bottom:0;left:0;right:0;z-index:100;width:100%;", ";"], breakpoint('xs', 'sm')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: flex-end;\n  "]))));
export var Overlay = styled(motion.div).withConfig({
  displayName: "elements__Overlay",
  componentId: "lafckj-1"
})(["position:fixed;min-width:100%;min-height:100%;background-color:rgba(0,0,0,0.5);z-index:99;"]);
export var Dialog = styled(motion.dialog).withConfig({
  displayName: "elements__Dialog",
  componentId: "lafckj-2"
})(["position:relative;width:", ";height:", ";z-index:999;display:flex;flex-direction:column;padding:", ";color:", ";font-size:", ";border-radius:", ";background:", ";", ";"], function (_ref) {
  var width = _ref.width;
  return width;
}, function (_ref2) {
  var height = _ref2.height;
  return height;
}, function (_ref3) {
  var padding = _ref3.padding;
  return padding;
}, function (_ref4) {
  var palette = _ref4.theme.palette;
  return palette.darkBlue;
}, function (_ref5) {
  var size = _ref5.theme.fonts.size;
  return size.medium;
}, function (_ref6) {
  var dimensions = _ref6.theme.dimensions;
  return dimensions.radius;
}, function (_ref7) {
  var palette = _ref7.theme.palette;
  return palette.white;
}, breakpoint('xs', 'sm')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    width: 100%;\n    margin: 0.4rem;\n  "]))));
export var Title = styled.p.withConfig({
  displayName: "elements__Title",
  componentId: "lafckj-3"
})(["text-transform:uppercase;font-weight:", ";font-size:", ";line-height:", ";"], function (_ref8) {
  var fonts = _ref8.theme.fonts;
  return fonts.weight.thick;
}, function (_ref9) {
  var size = _ref9.theme.fonts.size;
  return size.medium;
}, function (_ref10) {
  var size = _ref10.theme.fonts.size;
  return size.medium;
});